import type { ReactNode } from 'react'
import { Button } from './Button'
import { Dialog, DialogActions, DialogBody } from './Dialog'

export type ConfirmDialogProps = {
  open: boolean
  title: string
  description?: ReactNode
  confirmText?: string
  cancelText?: string
  danger?: boolean
  loading?: boolean
  onConfirm: () => void
  onClose: () => void
}

export function ConfirmDialog({ open, title, description, confirmText = '确认', cancelText = '取消', danger = false, loading = false, onConfirm, onClose }: ConfirmDialogProps) {
  return (
    <Dialog open={open} title={title} onClose={onClose}>
      <DialogBody>
        {description ? <div className="text-sm leading-6 text-[var(--color-muted)]">{description}</div> : null}
        <DialogActions>
          <Button variant="secondary" onClick={onClose} disabled={loading}>{cancelText}</Button>
          <Button variant={danger ? 'danger' : 'primary'} loading={loading} loadingMode="spinner" onClick={onConfirm} data-dialog-initial-focus>{confirmText}</Button>
        </DialogActions>
      </DialogBody>
    </Dialog>
  )
}
